import React, { Component, ChangeEvent } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faMinusSquare, faCheckSquare, faSquare } from "@fortawesome/free-solid-svg-icons";

import CheckboxTree from 'react-checkbox-tree';
import '/node_modules/react-checkbox-tree/lib/react-checkbox-tree.css';


interface ReltioMDMMigrationModalProps {
  show: boolean;
  error: string;
  message: string;
  reltioMDMSaaSLoggedIn: boolean;
  configs: any|null;
  handleClose: () => void;
  handleTriggerReltioMDMSaaSMigration: (exisConfig: string|null, migrate: boolean|false, mdmTenant: string, rdmTenant: string) => void;
  setErrorOrMsg: (error: boolean, msg: string) => void;
}

interface ReltioMDMMigrationModalState {
  configModeGrp: "download" | "migrate";
  mode: "fresh" | "append";
  file: File | null;
  checked: string[];
  expanded: string[];
  existingConfigStr: string | null;
  mdmTenant: string;
  rdmTenant: string;
}

export default class ReltioMDMMigrationModal extends Component<ReltioMDMMigrationModalProps, ReltioMDMMigrationModalState> {
  constructor(props: ReltioMDMMigrationModalProps) {
    super(props);
    this.state = {
      checked: [],
      expanded: ['srcSystem','lkpRS','sysRanks','dm'],
      configModeGrp: "download",
      mode: "fresh", 
      file: null, 
      existingConfigStr: null,
      mdmTenant: 'trainMDMW6XsckU',
      rdmTenant: 'trainRDMW6XsckU',
    };
  }

  handleModeChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (["fresh","append"].indexOf(event.target.value) > -1){
       this.setState({ mode: event.target.value as "fresh" | "append", file: null, existingConfigStr: null });
    }else if (["download","migrate"].indexOf(event.target.value) > -1){
       this.setState({ configModeGrp: event.target.value as "download" | "migrate", file: null, existingConfigStr: null });
    }
   
  };

    
  handleFileUpload = (event: ChangeEvent<HTMLInputElement>) => {
      this.setState({existingConfigStr: null });
      if (event.target.files && event.target.files.length > 0) {
        this.setState({ file: event.target.files[0] });

        const file = event.target.files?.[0] || null;


        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            try {
              const content = e.target?.result as string;
              const json = JSON.parse(content); // Validate JSON structure
              const jsonString = JSON.stringify(json, null, 2); // Format JSON as string
              this.setState({ existingConfigStr: jsonString});
              this.props.setErrorOrMsg(false, "Config loaded successfully");
            } catch (err) {
              this.props.setErrorOrMsg(true, "Invalid JSON file");
            }
          };
          reader.onerror = () => {
            this.props.setErrorOrMsg(true, "Error reading file");
          };
          reader.readAsText(file); // Read the file as text
        } else {
          this.props.setErrorOrMsg(true, "No file selected");
        }

      }
  };
  
  handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name in this.state) {
      this.setState(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (this.state.configModeGrp === 'download'){
      this.props.handleTriggerReltioMDMSaaSMigration(this.state.existingConfigStr, false, '','');
    }else{
      if (!this.state.mdmTenant || !this.state.rdmTenant){
        alert('MDM or RDM Tenant is missing');
        return;
      }
      this.props.handleTriggerReltioMDMSaaSMigration(this.state.existingConfigStr, true, this.state.mdmTenant, this.state.rdmTenant);
    }
  };
  
 

  render() {
    const { show, message, error,  handleClose, configs } = this.props;
    const fixedWidthStyle = { width: '240px' };

    return (
      <Modal show={show} onHide={handleClose}  backdrop="static" size="lg" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Reltio MDM SaaS Migration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
                <Form.Label>Migration Options</Form.Label>
                <Form.Check
                    type="radio"
                    label="Download the L3 configuration"
                    name="configModeGrp"
                    value="download"
                    checked={this.state.configModeGrp === "download"}
                    onChange={this.handleModeChange}
                />
                
                {this.state.configModeGrp === 'download' &&
                <div className="ml-3" style={{marginLeft: '20px'}}>
                  <Form.Check
                      type="radio"
                      label="Create a fresh Config"
                      name="configMode"
                      value="fresh"
                      checked={this.state.mode === "fresh"}
                      onChange={this.handleModeChange}
                  />
                  <Form.Check
                      type="radio"
                      label="Append with existing Config"
                      name="configMode"
                      value="append"
                      checked={this.state.mode === "append"}
                      onChange={this.handleModeChange}
                  />
                </div>
                }
                <Form.Check
                    type="radio"
                    label="Migrate to Reltio Tenant"
                    name="configModeGrp"
                    value="migrate"
                    checked={this.state.configModeGrp === "migrate"}
                    onChange={this.handleModeChange}
                />
                {this.state.configModeGrp === 'migrate' &&
                <div className="ml-3" style={{marginLeft: '20px'}}>
                    <Form.Group controlId="mdmTenant" className="mb-3">
                      <Form.Label style={{fontSize:"11px"}}>MDM Tenant</Form.Label>
                      <Form.Control
                          type="text"
                          style={fixedWidthStyle}
                          name="mdmTenant"
                          value={this.state.mdmTenant}
                          onChange={this.handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="rdmTenant" className="mb-3">
                      <Form.Label style={{fontSize:"11px"}}>RDM Tenant</Form.Label>
                      <Form.Control
                          type="text"
                          style={fixedWidthStyle}
                          name="rdmTenant"
                          value={this.state.rdmTenant}
                          onChange={this.handleChange}
                        />
                    </Form.Group>
                </div>
                }
            </Form.Group>
            
            {/* File Upload (Visible Only When 'Append' is Selected) */}
            {this.state.mode === "append" && (
                <div className="mt-1 ml-3">
                    <Form.Group controlId="formFile" className="mb-3">
                      <Form.Label style={{fontSize:"11px"}}>Upload existing Reltio L3 config</Form.Label>
                      <Form.Control type="file" accept=".json" onChange={this.handleFileUpload} placeholder="ttt"/>
                    </Form.Group>

                </div>
            )}
          
            
            <div className="my-3">
              <Form.Label>Migration Checklist</Form.Label>
              <div style={{maxHeight:'500px', overflowY: 'auto'}}>
                <CheckboxTree
                  nodes={this.props.configs}
                  checked={this.state.checked}
                  expanded={this.state.expanded}
                  onCheck={checked => this.setState({ checked })}
                  onExpand={expanded => this.setState({ expanded })}
                  icons={{
                    check: null,
                    uncheck: null,
                    halfCheck: <FontAwesomeIcon icon={faSquare} />, // Add a custom icon for half-checked if desired
                    expandClose: <FontAwesomeIcon icon={faPlusSquare} />,
                    expandOpen: <FontAwesomeIcon icon={faMinusSquare} />,
                    expandAll: <FontAwesomeIcon icon={faPlusSquare} />,
                    collapseAll: <FontAwesomeIcon icon={faMinusSquare} />,
                    parentClose: null,
                    parentOpen: null,
                    leaf: null,
                 }}
                />
              </div>
            </div>

            <Button variant="primary" className="w-100" onClick={this.handleSubmit}>
              Submit
            </Button>
            
          </Form>
          
        </Modal.Body>
      </Modal>
    );
  }
}
